import { z } from "zod";
import { LookupQuerySchema } from "./common";

export const EventCategorySlugSchema = z
  .string()
  .trim()
  .min(1, "ຕ້ອງປ້ອນ slug")
  .max(64)
  .regex(/^[a-z0-9_]+$/, "slug ຕ້ອງເປັນ a-z, 0-9, _");

export const EventCategorySchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  nameEn: z.string().nullable(),
  description: z.string().nullable(),
  logoStorageKey: z.string().nullable(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type EventCategoryDTO = z.infer<typeof EventCategorySchema>;

export const CreateEventCategorySchema = z.object({
  slug: EventCategorySlugSchema,
  name: z.string().min(1, "ຕ້ອງປ້ອນຊື່ຫມວດ"),
  nameEn: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  logoStorageKey: z.string().nullable().optional(),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export type CreateEventCategoryDTO = z.infer<typeof CreateEventCategorySchema>;

export const UpdateEventCategorySchema = CreateEventCategorySchema.partial();
export type UpdateEventCategoryDTO = z.infer<typeof UpdateEventCategorySchema>;

export const EventCategoryLookupItemSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  logoStorageKey: z.string().nullable().optional(),
});
export type EventCategoryLookupItemDTO = z.infer<
  typeof EventCategoryLookupItemSchema
>;

export { LookupQuerySchema as EventCategoryLookupQuerySchema };
export type EventCategoryLookupQueryDTO = z.infer<typeof LookupQuerySchema>;
